import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ConfigService } from '../../../core/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class TonnageService {

  private configData: any;
  private apiUrl: string;
  private RESOURCE_URL = '/tonnage-rating'


  constructor(private http: HttpClient,
    private configService: ConfigService,
    ) {
    this.configData = this.configService.getConfigData();
    this.apiUrl = this.configData.urls.API_URL;
  }

    /**
   * Gets a list of tonnge Ratings for LMPS
   * @param {string} trainId Train to be searched
   * @returns {Observable<any>}
   * @memberof TonnageService
   */
  fetchTonnageLMPS(trainId: string): Observable<any> {

    let headers = new HttpHeaders();
    const apiUrl = this.configData.urls.API_URL;
    headers = headers.append('Content-Type', 'application/json');
    return trainId === '' || trainId === null || trainId === undefined
      ? of({})
      : this.http.get(`${apiUrl}${this.RESOURCE_URL}?trainId=${trainId}`, {
          headers: headers});
  }


  /**
   * Gets a list of tonnge Ratings for LMTO
   * @param {string} division Division to be searched
   * @param {string} subdivision Subdivision to be searched
\  * @returns {Observable<any>}
   * @memberof TonnageService
   */
  fetchTonnageLMTO(division: string, subdivision: string, station: string): Observable<any> {

    let headers = new HttpHeaders();
    const apiUrl = this.configData.urls.API_URL;
    headers = headers.append('Content-Type', 'application/json');
    return  division === '' || division === null || division === undefined
      ? of({})
      : this.http.get(`${apiUrl}${this.RESOURCE_URL}/lmto?division=${division}&subdivision=${subdivision}&station=${station}`, {
          headers: headers});
          https://apiqa.csx.com/lms/v1/tonnage-rating/lmto?division=AY&subdivision=B1&station=QD
   3
  }

  fetchAllDivisionsTonnageLMTO(): Observable<any>  {
    let headers = new HttpHeaders();
    const apiUrl = this.configData.urls.API_URL;
    headers = headers.append('Content-Type', 'application/json');
    return this.http.get(`${apiUrl}${this.RESOURCE_URL}/lmto/download-all-divisions`, {
          headers: headers});

}

  fetchDivisions(): Observable<any>  {
      let headers = new HttpHeaders();
      const apiUrl = this.configData.urls.API_URL;
      headers = headers.append('Content-Type', 'application/json');
      return this.http.get(`${apiUrl}${this.RESOURCE_URL}/divisions`, {
            headers: headers});

  }

  fetchSubDivisions(division: string): Observable<any> {

    let headers = new HttpHeaders();
    const apiUrl = this.configData.urls.API_URL;
    headers = headers.append('Content-Type', 'application/json');
    return  division === '' || division === null || division === undefined
      ? of({})
      : this.http.get(`${apiUrl}${this.RESOURCE_URL}/subDivisions?division=${division}`, {
          headers: headers});
  }

  fetchStations(division: string, subDivision: string): Observable<any> {

    let headers = new HttpHeaders();
    const apiUrl = this.configData.urls.API_URL;
    headers = headers.append('Content-Type', 'application/json');
    return  division === '' || division === null || division === undefined
        || subDivision === '' || subDivision === null || subDivision === undefined
      ? of({})
      : this.http.get(`${apiUrl}${this.RESOURCE_URL}/stations?division=${division}&subdivision=${subDivision}`, {
          headers: headers});
  }
}
